import React from 'react';
import { useNavigate } from 'react-router-dom';

import play from '../../play.jpg';
import play2 from '../../playy.png';

const StarRating = ({ rating }) => {
    const stars = parseFloat(rating).toFixed(1);

    return (
        <div className='absolute top-1 right-1 rounded backdrop-blur text-white shadow-sm z-10 p-1'>
            <span className='flex items-center space-x-1'>
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='#ff0'
                    fillRule='evenodd'
                    viewBox='0 0 24 24'
                    strokeWidth='1.5'
                    stroke='#ff0'
                    className='w-4 h-4'
                >
                    <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        d='M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z'
                    />
                </svg>
                <span className='text-xs font-medium'>{stars}</span>
            </span>
        </div>
    );
};

const Card = ({ item }) => {
    const navigate = useNavigate();
    let { title, vote_average: stars, release_date, poster_path, media_type, id } = item;
    if (media_type === 'tv') {
        title = item.original_name;
        release_date = item.first_air_date;
    }
    const releaseYear = new Date(release_date).getFullYear();
    const image = `https://image.tmdb.org/t/p/w200${poster_path}`;
    const mediaType = media_type ? media_type[0].charAt(0).toUpperCase() + media_type.slice(1) : '';

    const titleMaxLength = 30;
    const truncatedTitle = title.length > titleMaxLength ? title.substring(0, titleMaxLength) + '...' : title;

    const handleClick = () => {
        navigate('/watch/' + media_type + '/' + id);
    };

    return (
        <>
            <div onClick={handleClick} className='w-44 flex-1  flex flex-col '>
                <div className='shadow-lg group relative rounded-lg bg-transparent'>
                    <StarRating rating={stars} />
                    <img
                        className='rounded-lg h-60 w-full sm:h-52 md:h-64 lg:h-72 object-cover'
                        alt='img'
                        src={image}
                        loading='lazy'
                        style={{}}
                    />

                    <div
                        style={{ background: 'rgba(0,0,0,0.25)', transition: 'all 0.5s' }}
                        className='absolute rounded-lg opacity-0 group-hover:opacity-100 h-full w-full text-center top-0'
                    >
                        <div className='flex items-center justify-center h-full' style={{ zIndex: '1' }}>
                            <img className='w-20 h-20' src={play} alt='play' />
                        </div>
                    </div>
                </div>
                <div className='p-2 flex flex-col flex-grow'>
                    <div className='flex justify-between flex-grow'>
                        <span className='font-semibold text-xs md:text-sm'>{truncatedTitle}</span>
                    </div>
                    <div className='flex justify-between items-center'>
                        <span className='text-xs font-semibold text-secondary'>{releaseYear}</span>
                        <span
                            className={`text-xs font-medium ${
                                mediaType === 'Movie' ? 'text-sky-700' : 'text-pink-800'
                            }`}
                        >
                            {mediaType}
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
};
export default Card;
